Ext.define('SA.model.GeoUnit', {
    constructor({id, singularName, pluralName, subUnits}) {
        this.id = id;
        this.singularName = singularName;
        this.pluralName = pluralName;
        this.subUnits = subUnits;
    },

    getId() {
        return this.id;
    },

    getPluralName() {
        return this.pluralName;
    },

    getSingularName() {
        return this.singularName;
    },

    getSubUnits() {
        return this.subUnits;
    },

    hasId(id) {
        return this.getId() === id;
    }
});